import { getRuntimeEnvironment } from '../utils/getRuntimeEnvironment';

export function isAnnouncementsEnabled(): boolean {
  return getRuntimeEnvironment() !== 'production';
}
